export default __webpack_public_path__ + "419fa9862ce3b4304353efb6fd8e90a7.png";